import * as R from 'ramda';

export default function ECATMaturityDomainController(
  $q,
  $rootScope,
  $scope,
  alerts,
  ecatDataService,
  ecatSharedModelService,
  userService,
) {
  const vm = this;

  vm.canExpand = true;
  vm.isExpanded = false;
  vm.assessmentFactorViewType = 'graphical';
  vm.handleExpandMaturityDomain = _handleExpandMaturityDomain;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    userService.getUserPermissionSet('ecat').then((permissions) => {
      vm.permissions = permissions;
    });
    _extractStatusClasses();
    _extractScoreClasses();
  }

  function _handleExpandMaturityDomain() {
    vm.isExpanded = !vm.isExpanded;
  }

  function _extractScoreClasses() {
    R.forEach(
      (assessmentFactor) => {
        R.forEach(
          (contributionComponent) => {
            _setContributionComponentClass(contributionComponent);
          },
          assessmentFactor.contributionComponents
        );
      },
      vm.maturityDomain.assessmentFactors
    );
  }

  function _extractStatusClasses() {
    if (vm.maturityDomain.statusId === 0) {
      vm.StatusClass1 = 'score--none';
      vm.StatusClass2 = 'score--none';
      vm.StatusClass3 = 'score--none';
      vm.StatusClass4 = 'score--none';
      vm.StatusClass5 = 'score--none';
    } else if (vm.maturityDomain.statusId === 1) {
      vm.StatusClass1 = 'score--baseline';
      vm.StatusClass2 = '';
      vm.StatusClass3 = '';
      vm.StatusClass4 = '';
      vm.StatusClass5 = '';
    } else if (vm.maturityDomain.statusId === 2) {
      vm.StatusClass1 = 'score--evolving';
      vm.StatusClass2 = 'score--evolving';
      vm.StatusClass3 = '';
      vm.StatusClass4 = '';
      vm.StatusClass5 = '';
    } else if (vm.maturityDomain.statusId === 3) {
      vm.StatusClass1 = 'score--intermediate';
      vm.StatusClass2 = 'score--intermediate';
      vm.StatusClass3 = 'score--intermediate';
      vm.StatusClass4 = '';
      vm.StatusClass5 = '';
    } else if (vm.maturityDomain.statusId === 4) {
      vm.StatusClass1 = 'score--advanced';
      vm.StatusClass2 = 'score--advanced';
      vm.StatusClass3 = 'score--advanced';
      vm.StatusClass4 = 'score--advanced';
      vm.StatusClass5 = '';
    } else if (vm.maturityDomain.statusId === 5) {
      vm.StatusClass1 = 'score--innovative';
      vm.StatusClass2 = 'score--innovative';
      vm.StatusClass3 = 'score--innovative';
      vm.StatusClass4 = 'score--innovative';
      vm.StatusClass5 = 'score--innovative';
    }
  }

  function _setContributionComponentClass(contributionComponent) {
    if (contributionComponent.score === 0) {
      contributionComponent.ScoreClass1 = 'score--none';
      contributionComponent.ScoreClass2 = 'score--none';
      contributionComponent.ScoreClass3 = 'score--none';
      contributionComponent.ScoreClass4 = 'score--none';
      contributionComponent.ScoreClass5 = 'score--none';
    }

    if (contributionComponent.score === 1) {
      contributionComponent.ScoreClass1 = 'score--baseline';
      contributionComponent.ScoreClass2 = '';
      contributionComponent.ScoreClass3 = '';
      contributionComponent.ScoreClass4 = '';
      contributionComponent.ScoreClass5 = '';
    }

    if (contributionComponent.score === 2) {
      contributionComponent.ScoreClass1 = 'score--evolving';
      contributionComponent.ScoreClass2 = 'score--evolving';
      contributionComponent.ScoreClass3 = '';
      contributionComponent.ScoreClass4 = '';
      contributionComponent.ScoreClass5 = '';
    }

    if (contributionComponent.score === 3) {
      contributionComponent.ScoreClass1 = 'score--intermediate';
      contributionComponent.ScoreClass2 = 'score--intermediate';
      contributionComponent.ScoreClass3 = 'score--intermediate';
      contributionComponent.ScoreClass4 = '';
      contributionComponent.ScoreClass5 = '';
    }

    if (contributionComponent.score === 4) {
      contributionComponent.ScoreClass1 = 'score--advanced';
      contributionComponent.ScoreClass2 = 'score--advanced';
      contributionComponent.ScoreClass3 = 'score--advanced';
      contributionComponent.ScoreClass4 = 'score--advanced';
      contributionComponent.ScoreClass5 = '';
    }

    if (contributionComponent.score === 5) {
      contributionComponent.ScoreClass1 = 'score--innovative';
      contributionComponent.ScoreClass2 = 'score--innovative';
      contributionComponent.ScoreClass3 = 'score--innovative';
      contributionComponent.ScoreClass4 = 'score--innovative';
      contributionComponent.ScoreClass5 = 'score--innovative';
    }
  }
}

ECATMaturityDomainController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'ecatDataService',
  'ecatSharedModelService',
  'userService'
];
